export default __webpack_public_path__ + "static/media/fr.8edd7246.png";